module.exports = __webpack_public_path__ + "img/symbol_10_x8.b4059f3b.png";